
import { FileValidationResult } from './types';

export class FileValidationService {
  /**
   * Validates file size and type
   */
  static validateFile(file: File, maxSizeMB: number = 5, allowedTypes: string[] = []): FileValidationResult {
    // Check file size
    const fileSize = file.size / 1024 / 1024; // Convert to MB
    if (fileSize > maxSizeMB) {
      return {
        valid: false,
        error: `File is too large. Maximum size is ${maxSizeMB}MB.`
      };
    }

    // Check file type if allowed types are specified
    if (allowedTypes.length > 0) {
      const fileType = file.type;
      if (!allowedTypes.includes(fileType)) {
        return {
          valid: false,
          error: `File type not allowed. Allowed types: ${allowedTypes.join(', ')}`
        };
      }
    }

    return { valid: true, error: null };
  }

  /**
   * Overload for validateFile that accepts options object
   */
  static validateFileWithOptions(
    file: File, 
    options: { maxSizeInMB: number; fileType?: any }
  ): FileValidationResult {
    const maxSizeMB = options.maxSizeInMB || 5;
    const allowedTypes: string[] = [];
    return this.validateFile(file, maxSizeMB, allowedTypes);
  }
}
